import { faker } from '@faker-js/faker'
import { defineFakeRoute } from 'vite-plugin-fake-server/client'

/**
 * 模拟用户相关接口
 */
export default defineFakeRoute([
  {
    url: '/mock/user/login',
    method: 'post',
    /**
     * 模拟登录接口，返回账号、令牌与头像地址
     */
    response: ({ body }) => {
      return {
        error: '',
        code: 1,
        data: {
          account: `${body.account === 'admin' ? '研发-王凯' : body.account}`,
          token: `${body.account}:${faker.internet.jwt()}`,
          avatar: 'https://yun-campus-res.oss-cn-shenzhen.aliyuncs.com/public/images/logo.svg',
        },
      }
    },
  },
  {
    url: '/mock/user/permission',
    method: 'get',
    /**
     * 模拟权限接口，根据 token 前缀返回不同权限集
     */
    response: ({ headers }) => {
      let permissions: string[] = []
      if (headers.token?.indexOf('admin') === 0) {
        permissions = [
          'permission.browse',
          'permission.create',
          'permission.edit',
          'permission.remove',
        ]
      }
      else if (headers.token?.indexOf('test') === 0) {
        permissions = [
          'permission.browse',
        ]
      }
      return {
        error: '',
        code: 1,
        data: {
          permissions,
        },
      }
    },
  },
  {
    url: '/mock/user/password/edit',
    method: 'post',
    /**
     * 模拟修改密码接口，固定返回成功
     */
    response: () => {
      return {
        error: '',
        code: 1,
        data: {
          isSuccess: true,
        },
      }
    },
  },
  {
    url: '/mock/user/user_safe_info',
    method: 'get',
    /**
     * 模拟用户安全信息接口，返回用户安全信息
     */
    response: () => {
      return {
        error: '',
        code: 1,
        data: {
          user_level: 1,
          is_bind_wx: 1,
          last_login_time: `2025-12-01 10:40 湖南省长沙市`,
        },
      }
    },
  },
  {
    url: '/mock/user/check_pwd',
    method: 'get',
    /**
     * 模拟校验密码状态接口，返回校验结果
     */
    response: () => {
      return {
        error: '',
        code: 1,
        data: {
          is_trust: 1,
        },
      }
    },
  },
])
